// extracted by mini-css-extract-plugin
module.exports = {"amount":"AmountValue_amount__3xVvu"};